import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { WORKPLACE_PATH } from 'config';
import { useDispatch, useSelector } from 'store';
import { useWorkspace } from 'contexts/WorkspaceContext';

import { getPath } from 'store/slices/workspace';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }) => {
    const dispatch = useDispatch();
    const { isLoggedIn } = useAuth();
    const { updateWorkspaceId } = useWorkspace();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(
                getPath({
                    workspaceId: localStorage.getItem('workspaceId') || null
                },(data) => {
                    const url = data.redirectTo === "project" ? `/w/${data.workspaceId}/p/${data.projectId}` : `/w/${data.workspaceId}/${data.redirectTo}`
                    updateWorkspaceId(data.workspaceId);
                    navigate(url)
                })
            );
            // navigate(WORKPLACE_PATH, { replace: true });
        }
    }, [isLoggedIn, dispatch, navigate]);

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
